export default {
    filters: {
        currencyFormatter(value) {
            return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(value)
        }
    }
}